import { useRef } from 'react';
import useScrollReveal from '../../hooks/useScrollReveal';
import styles from './perksScreen.module.css';

import romiB from '../../images/romi_1.webp';
import romiC from '../../images/romi_3.webp';
import romiD from '../../images/romi_4.webp';
import romiE from '../../images/romi_5.webp';
import romiF from '../../images/romi-hero.webp';
import maximovaPro from '../../assets/ערכת מקסימובה.webp';

const perks = [
  { img: maximovaPro, title: 'ערכת פרימיום מלאה',    desc: 'חומרים של Maximova  -  תתחילי לעבוד מיד' },
  { img: romiB,       title: 'תעודה בינלאומית',        desc: 'הסמכה מטעם Maximova ב-60 מדינות', imgPos: 'center 20%' },
  { img: romiC,       title: 'ליווי צמוד אחרי הקורס', desc: 'תמיד זמינה לכל שאלה וחשש' },
  { img: romiD,       title: 'שיווק ובידול',           desc: 'איך לבנות נוכחות ולהביא לקוחות' },
  { img: romiE,       title: 'מיינדסט של מנצחת',       desc: 'ארגז כלים מנטלי להתגבר על הפחדים' },
  { img: romiF,       title: '100% שקיפות',            desc: 'כל הידע, בלי לשמור טריקים' },
];

const sparklePos = [
  { top: '8%',     right: '9%',  d: 0,   s: 7, w: 3 },
  { top: '22%',    left: '4%',   d: 1.4, s: 8, w: 2 },
  { top: '50%',    right: '5%',  d: 2.6, s: 6, w: 3 },
  { bottom: '20%', left: '6%',   d: 0.9, s: 9, w: 2 },
  { top: '38%',    right: '16%', d: 3.2, s: 7, w: 2 },
  { bottom: '32%', right: '11%', d: 1.8, s: 8, w: 4 },
];

function PerksScreen() {
  const sectionRef = useRef(null);
  useScrollReveal(sectionRef);

  return (
    <section className={styles.perks} ref={sectionRef}>
      <div className={styles.bg} />
      <div className={styles.glowTR} />
      <div className={styles.glowBL} />

      {sparklePos.map((p, i) => (
        <div
          key={i}
          className={styles.sparkle}
          style={{
            top: p.top, right: p.right, bottom: p.bottom, left: p.left,
            animationDelay: `${p.d}s`, animationDuration: `${p.s}s`,
            width: `${p.w}px`, height: `${p.w}px`,
          }}
        />
      ))}

      <div className={styles.container}>
        {/* Decorative bridge divider */}
        <div className={styles.bridgeDivider}>
          <span className={styles.bridgeLine} />
          <span className={styles.bridgeDiamond}>✦</span>
          <span className={styles.bridgeLine} />
        </div>

        <div className={styles.sh} data-sr="0">
          <div className={styles.shBridge}>...ובכל אחד מהם</div>
          <h2 className={styles.shH2}>
            תקבלי <em className={styles.em}>הרבה יותר</em> מסתם קורס
          </h2>
          <p className={styles.shP}>כי אני לא מלמדת רק טכניקה - אני נותנת לך את הכל כדי שתצליחי מהיום הראשון</p>
        </div>

        <div className={styles.grid}>
          {perks.map((p, i) => (
            <div key={i} className={styles.pr} data-sr={String(0.05 + i * 0.08)}>
              {/* Full-height image panel */}
              <div className={styles.prImgPanel}>
                <img src={p.img} alt="רומי פרץ" className={styles.prImg} loading="lazy" style={p.imgPos ? { objectPosition: p.imgPos } : undefined} />
                <div className={styles.prImgOverlay} />
              </div>
              {/* Text */}
              <div className={styles.prContent}>
                <div className={styles.prTt}>{p.title}</div>
                <div className={styles.prTd}>{p.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PerksScreen;
